import React, { useState } from 'react';
import { StarIcon, HandThumbUpIcon } from '@heroicons/react/24/outline';
import { PageHeader, SegmentedToggle } from '../../components/ui';
import OrderRatings from './OrderRatings';
import PlatformRatings from './PlatformRatings';
import './ratings.css';

const SHELL_CLASS =
  'ratings-shell min-h-[calc(100vh-4rem)] bg-white px-4 py-6 dark:bg-slate-900/40 sm:px-6 lg:px-8 lg:py-8';

const Ratings = () => {
  const [tab, setTab] = useState('order');

  return (
    <div className={SHELL_CLASS}>
      <div className="mx-auto max-w-5xl space-y-6">
        <PageHeader
          title="Ratings"
          description="Customer ratings for orders and the platform app."
        />

        <SegmentedToggle
          ariaLabel="Ratings type"
          value={tab}
          onChange={setTab}
          options={[
            { value: 'order', label: 'Order Ratings', icon: StarIcon },
            { value: 'platform', label: 'Platform Ratings', icon: HandThumbUpIcon },
          ]}
        />

        {tab === 'order' ? <OrderRatings /> : <PlatformRatings />}
      </div>
    </div>
  );
};

export default Ratings;
